export const useCookieConsent = () =>
  useState<string>("cookie-consent", () => "");

export const useCookieConsentBannerDismissed = () =>
  useState<boolean>("cookie-consent-banner-dismissed", () => false);
